import { useModal } from '~/composables/useModal';

interface IEquipmentModalProps {
  title: string;
  subtitle: string;
  featuresTitle?: string;
  features?: string[];
  featureSections?: Array<{ title: string; items: string[] }>;
  videoSrc: string;
  firstFrameUrl: string;
  hasAudio?: boolean;
}

export function useEquipmentSectionModal() {
  function openEquipmentModal(props: IEquipmentModalProps, options?: { onClose?: () => void }) {
    const { modalShow } = useModal({
      component: () => import('~/components/v5/system/EquipmentSectionModal.vue'),
      componentProps: props,
      options: {
        closeCallback: options?.onClose,
      },
      modalProps: {
        componentName: 'EquipmentSectionModal',
        adaptive: true,
        width: '95%',
        maxWidth: 1000,
        height: 'auto',
        // maxHeight is handled in CSS/component but we can set a safe max here too
      },
    });

    modalShow();
  }

  return {
    openEquipmentModal,
  };
}
